/* tslint:disable */
/* eslint-disable */
/**
 * MOBEL Proxy Api Documentation
 * MOBEL Proxy Api Documentation
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomerTimeFrame,
    CustomerTimeFrameFromJSON,
    CustomerTimeFrameFromJSONTyped,
    CustomerTimeFrameToJSON,
} from './';

/**
 * 
 * @export
 * @interface AvailableAppointment
 */
export interface AvailableAppointment {
    /**
     * 
     * @type {string}
     * @memberof AvailableAppointment
     */
    date?: string;
    /**
     * 
     * @type {Array<CustomerTimeFrame>}
     * @memberof AvailableAppointment
     */
    frames?: Array<CustomerTimeFrame>;
}

export function AvailableAppointmentFromJSON(json: any): AvailableAppointment {
    return AvailableAppointmentFromJSONTyped(json, false);
}

export function AvailableAppointmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableAppointment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'frames': !exists(json, 'frames') ? undefined : ((json['frames'] as Array<any>).map(CustomerTimeFrameFromJSON)),
    };
}

export function AvailableAppointmentToJSON(value?: AvailableAppointment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'frames': value.frames === undefined ? undefined : ((value.frames as Array<any>).map(CustomerTimeFrameToJSON)),
    };
}


